import { render, staticRenderFns } from "./MobileAlertRSCard.vue?vue&type=template&id=c0d11976&scoped=true&"
import script from "./MobileAlertRSCard.vue?vue&type=script&lang=js&"
export * from "./MobileAlertRSCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileAlertRSCard.vue?vue&type=style&index=0&id=c0d11976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d11976",
  null
  
)

export default component.exports